import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=64c27bca&scoped=true"
import script from "./Heading.vue?vue&type=script&lang=ts"
export * from "./Heading.vue?vue&type=script&lang=ts"
import style0 from "./Heading.vue?vue&type=style&index=0&id=64c27bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c27bca",
  null
  
)

export default component.exports